<template>
	<div v-if="visible" class="ld-tabbar-dock">
	<nav ref="tabbar" class="ld-tabbar">
		<span
			class="ld-tab-slider"
			:class="{ 'is-ready': sliderReady }"
			:style="sliderStyle"
			aria-hidden="true"
		></span>
		<a
			v-for="item in tabs"
			:key="item.key"
			ref="tabEls"
			class="ld-tab"
			:class="{ 'is-active': item.active, 'is-pop': popKey === item.key }"
			:href="item.href"
			:aria-label="$t(item.labelKey)"
			:aria-current="item.active ? 'page' : null"
			@click.prevent="onTab(item)"
			@touchstart.passive="prefetch(item)"
		>
			<span class="ld-tab-hit">
				<span class="ld-tab-burst" aria-hidden="true"></span>
				<span class="ld-tab-icon" aria-hidden="true">
					<span class="ld-tab-svg is-outline" v-html="item.outline"></span>
					<span class="ld-tab-svg is-fill" v-html="item.fill"></span>
				</span>
			</span>
		</a>
	</nav>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { prefetchRoute } from '@/router/asyncViews'

const LAST_TRADE_KEY = 'ldLastTradeQuery'
const DEFAULT_TRADE_QUERY = {
	code: 'bitcoin',
	type: '2',
	id: '1932241773170528257'
}

const ICONS = {
	home: {
		outline: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.6 10.6L12 4.4l7.4 6.2V18.6c0 .9-.7 1.6-1.6 1.6h-3.6v-5.1H9.8v5.1H6.2c-.9 0-1.6-.7-1.6-1.6v-8z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>`,
		fill: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 3.6L3.8 10.5v8.2c0 1.1.9 2 2 2h4.2v-5.6h4v5.6h4.2c1.1 0 2-.9 2-2v-8.2L12 3.6z" fill="currentColor"/></svg>`
	},
	market: {
		outline: `<svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.8 13.2L7 8.6L10.4 11.8L17.2 5.2" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.4 5.2H17.2V9" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
		fill: `<svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.8 13.2L7 8.6L10.4 11.8L17.2 5.2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.4 5.2H17.2V9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>`
	},
	trade: {
		outline: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.4 8.2h12.4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M13.6 5.2L18.2 8.2 13.6 11.2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M19.6 15.8H7.2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M10.4 12.8L5.8 15.8 10.4 18.8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
		fill: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.2 8.2h12.2" stroke="currentColor" stroke-width="2.15" stroke-linecap="round"/><path d="M13.2 4.9l5.4 3.3-5.4 3.3V4.9z" fill="currentColor"/><path d="M19.8 15.8H7.6" stroke="currentColor" stroke-width="2.15" stroke-linecap="round"/><path d="M10.8 12.5l-5.4 3.3 5.4 3.3v-6.6z" fill="currentColor"/></svg>`
	},
	orders: {
		outline: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="6.3" cy="7" r="1.45" stroke="currentColor" stroke-width="1.8"/><path d="M10 7h8.2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><circle cx="6.3" cy="12" r="1.45" stroke="currentColor" stroke-width="1.8"/><path d="M10 12h8.2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><circle cx="6.3" cy="17" r="1.45" stroke="currentColor" stroke-width="1.8"/><path d="M10 17h5.6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>`,
		fill: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="6.3" cy="7" r="2.05" fill="currentColor"/><path d="M10 7h8.2" stroke="currentColor" stroke-width="2.05" stroke-linecap="round"/><circle cx="6.3" cy="12" r="2.05" fill="currentColor"/><path d="M10 12h8.2" stroke="currentColor" stroke-width="2.05" stroke-linecap="round"/><circle cx="6.3" cy="17" r="2.05" fill="currentColor"/><path d="M10 17h5.6" stroke="currentColor" stroke-width="2.05" stroke-linecap="round"/></svg>`
	},
	assets: {
		outline: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.2 8.6V7.3c0-1 .8-1.8 1.8-1.8h8c1 0 1.8.8 1.8 1.8v1.3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><rect x="3.8" y="8.6" width="16.4" height="10.6" rx="2.3" stroke="currentColor" stroke-width="1.8"/><circle cx="16.4" cy="13.9" r="1.15" stroke="currentColor" stroke-width="1.8"/></svg>`,
		fill: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.6 5.1h8.8c1.3 0 2.3 1 2.3 2.3v1.2H5.3V7.4c0-1.3 1-2.3 2.3-2.3z" fill="currentColor"/><rect x="3.4" y="8.2" width="17.2" height="11.2" rx="2.4" fill="currentColor"/><circle cx="16.4" cy="13.9" r="1.35" fill="var(--ld-tabbar-chip, #ececec)"/></svg>`
	}
}

function readLastTrade() {
	try {
		const raw = sessionStorage.getItem(LAST_TRADE_KEY)
		if (!raw) return null
		const q = JSON.parse(raw)
		return q && q.code ? q : null
	} catch (e) {
		return null
	}
}

function writeLastTrade(query) {
	if (!query || !query.code) return
	try {
		sessionStorage.setItem(LAST_TRADE_KEY, JSON.stringify({
			code: query.code,
			type: query.type,
			id: query.id
		}))
	} catch (e) { /* ignore */ }
}

export default {
	name: 'MobileTabBar',
	data() {
		return {
			popKey: '',
			lastTradeQuery: readLastTrade(),
			sliderReady: false,
			sliderStyle: {
				width: '64px',
				height: '100%',
				opacity: 0,
				transform: 'translate(2px, 2px)'
			},
			_popTimer: null
		}
	},
	computed: {
		...mapState(['isPc', 'innerWidth']),
		visible() {
			if (!this.isPc) return true
			const w = Number(this.innerWidth) || (typeof window !== 'undefined' ? window.innerWidth : 0)
			return w > 0 && w <= 768
		},
		routeName() {
			return (this.$route && this.$route.name) || ''
		},
		tradeTo() {
			const q = this.lastTradeQuery
			if (q && q.code) {
				return { name: 'cruuency', query: q }
			}
			return { name: 'cruuency', query: DEFAULT_TRADE_QUERY }
		},
		tradeHref() {
			const q = (this.tradeTo && this.tradeTo.query) || DEFAULT_TRADE_QUERY
			const params = new URLSearchParams()
			if (q.code) params.set('code', String(q.code))
			if (q.type != null && q.type !== '') params.set('type', String(q.type))
			if (q.id != null && q.id !== '') params.set('id', String(q.id))
			const qs = params.toString()
			return qs ? `/cruuency?${qs}` : '/cruuency'
		},
		tabs() {
			const tradeTo = this.tradeTo
			return [
				{
					key: 'home',
					labelKey: 'lendingMenu.home',
					routeName: 'home',
					to: { name: 'home' },
					href: '/',
					active: this.routeName === 'home',
					...ICONS.home
				},
				{
					key: 'market',
					labelKey: 'lendingMenu.market',
					routeName: 'market',
					to: { name: 'market' },
					href: '/market',
					active: this.routeName === 'market',
					...ICONS.market
				},
				{
					key: 'trade',
					labelKey: 'lendingMenu.trade',
					routeName: 'cruuency',
					to: tradeTo,
					href: this.tradeHref,
					active: this.routeName === 'cruuency',
					...ICONS.trade
				},
				{
					key: 'orders',
					labelKey: 'lendingMenu.orders',
					routeName: 'orders',
					to: { name: 'orders' },
					href: '/orders',
					active: this.routeName === 'orders',
					...ICONS.orders
				},
				{
					key: 'assets',
					labelKey: 'lendingMenu.assets',
					routeName: 'profile',
					to: { name: 'profile' },
					href: '/profile',
					active: this.isAssetsFamily,
					...ICONS.assets
				}
			]
		},
		isAssetsFamily() {
			return ['profile', 'deposit', 'withdraw', 'moneyLog', 'invite', 'notification', 'identity'].indexOf(this.routeName) >= 0
		},
		activeIndex() {
			return this.tabs.findIndex((item) => item.active)
		}
	},
	watch: {
		visible: {
			immediate: true,
			handler(val) {
				this.syncHtmlClass(val)
				if (val) this.$nextTick(this.updateSlider)
			}
		},
		activeIndex() {
			this.$nextTick(this.updateSlider)
		},
		'$route': {
			immediate: true,
			handler(to) {
				if (to && to.name === 'cruuency') {
					this.lastTradeQuery = {
						code: to.query.code,
						type: to.query.type,
						id: to.query.id
					}
					writeLastTrade(this.lastTradeQuery)
				}
			}
		}
	},
	mounted() {
		this._onResize = () => this.updateSlider()
		window.addEventListener('resize', this._onResize)
		this.$nextTick(this.updateSlider)
	},
	beforeDestroy() {
		this.syncHtmlClass(false)
		if (this._popTimer) clearTimeout(this._popTimer)
		if (this._onResize) window.removeEventListener('resize', this._onResize)
	},
	methods: {
		syncHtmlClass(on) {
			if (typeof document === 'undefined') return
			document.documentElement.classList.toggle('has-ld-tabbar', !!on)
		},
		prefetch(item) {
			if (item && item.routeName) prefetchRoute(item.routeName).catch(() => {})
		},
		playPop(key) {
			this.popKey = ''
			this.$nextTick(() => {
				this.popKey = key
			})
			if (this._popTimer) clearTimeout(this._popTimer)
			this._popTimer = setTimeout(() => {
				this.popKey = ''
			}, 640)
		},
		sameTarget(item) {
			if (!item.active) return false
			if (item.key !== 'trade') return true
			const q = this.$route.query || {}
			const toq = (item.to && item.to.query) || {}
			return String(q.code || '') === String(toq.code || '')
		},
		tabEls() {
			const els = this.$refs.tabEls
			if (!els) return []
			return Array.isArray(els) ? els : [els]
		},
		placeSlider(index) {
			const bar = this.$refs.tabbar
			const el = this.tabEls()[index]
			if (!bar || !el || index < 0) {
				this.sliderStyle = Object.assign({}, this.sliderStyle, { opacity: 0 })
				return
			}
			this.sliderStyle = {
				width: `${el.offsetWidth}px`,
				height: `${el.offsetHeight}px`,
				opacity: 1,
				transform: `translate(${el.offsetLeft}px, ${el.offsetTop}px)`
			}
			if (!this.sliderReady) {
				this.$nextTick(() => {
					this.sliderReady = true
				})
			}
		},
		updateSlider() {
			this.placeSlider(this.activeIndex)
		},
		onTab(item) {
			this.playPop(item.key)
			this.prefetch(item)
			const index = this.tabs.findIndex((tab) => tab.key === item.key)
			this.$nextTick(() => this.placeSlider(index))
			if (this.sameTarget(item)) return
			this.$router.push(item.to).catch((err) => {
				if (!err || err.name !== 'NavigationDuplicated') {
					return
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped>
/* 跟目标站 nav_mobile：fixed 贴底、整宽 flex 居中，不要 transform，不要 inset:0 壳 */
.ld-tabbar-dock {
	position: fixed;
	left: 0;
	right: 0;
	bottom: calc(0.24rem + var(--ld-safe-bottom, 0px));
	z-index: 9;
	display: flex;
	justify-content: center;
	pointer-events: none;
}

.ld-tabbar {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	width: max-content;
	max-width: calc(100% - 32px);
	height: var(--ld-tabbar-height, 56px);
	padding: 2px;
	box-sizing: border-box;
	background: var(--ld-tabbar-bg, var(--ld-bg-elevated, #fff));
	border: 1px solid var(--ld-tabbar-border, var(--ld-border, #ececec));
	border-radius: 999px;
	box-shadow: var(--ld-tabbar-shadow, var(--ld-shadow));
	color: var(--ld-text-secondary, #888);
	pointer-events: auto;
}

.ld-tab-slider {
	position: absolute;
	left: 0;
	top: 0;
	border-radius: 999px;
	background: var(--ld-tabbar-chip, var(--ld-bg-active, #f2f2f2));
	pointer-events: none;
	z-index: 0;
}

.ld-tab-slider.is-ready {
	transition: transform 0.42s cubic-bezier(0.22, 1, 0.36, 1),
		width 0.42s cubic-bezier(0.22, 1, 0.36, 1),
		height 0.42s cubic-bezier(0.22, 1, 0.36, 1);
}

.ld-tab {
	position: relative;
	z-index: 1;
	flex: 0 0 auto;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 64px;
	height: 100%;
	color: inherit;
	text-decoration: none;
	-webkit-tap-highlight-color: transparent;
	user-select: none;
}

.ld-tab-hit {
	position: relative;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 999px;
	background: transparent;
}

.ld-tab-burst {
	position: absolute;
	width: 36px;
	height: 36px;
	border-radius: 999px;
	background: var(--ld-tabbar-chip, var(--ld-bg-active, #f2f2f2));
	opacity: 0;
	transform: scale(0.35);
	pointer-events: none;
}

.ld-tab-icon {
	position: relative;
	width: 24px;
	height: 24px;
	color: var(--ld-text, #111);
	transform-origin: 50% 70%;
}

.ld-tab-svg {
	position: absolute;
	inset: 0;
	display: flex;
	align-items: center;
	justify-content: center;
}

.ld-tab-svg.is-fill {
	opacity: 0;
	transform: scale(0.72);
}

.ld-tab-svg ::v-deep svg {
	display: block;
}

.ld-tab.is-active .ld-tab-icon {
	color: var(--ld-text, #111);
}

.ld-tab.is-active .ld-tab-svg.is-outline {
	opacity: 0;
	transform: scale(0.86);
}

.ld-tab.is-active .ld-tab-svg.is-fill {
	opacity: 1;
	transform: scale(1);
}

.ld-tab.is-pop .ld-tab-icon {
	animation: ld-tab-pop 0.58s cubic-bezier(0.22, 1.4, 0.36, 1) both;
}

.ld-tab.is-pop .ld-tab-burst {
	animation: ld-tab-burst 0.52s ease-out both;
}

.ld-tab.is-active .ld-tab-svg,
.ld-tab:not(.is-pop) .ld-tab-svg {
	transition: opacity 0.18s ease, transform 0.22s cubic-bezier(0.22, 1, 0.36, 1);
}

@keyframes ld-tab-pop {
	0% { transform: scale(0.82) translateY(3px); }
	38% { transform: scale(1.22) translateY(-3px); }
	62% { transform: scale(0.94) translateY(1px); }
	82% { transform: scale(1.06) translateY(-1px); }
	100% { transform: scale(1) translateY(0); }
}

@keyframes ld-tab-burst {
	0% { opacity: 0.72; transform: scale(0.28); }
	45% { opacity: 0.42; }
	100% { opacity: 0; transform: scale(1.85); }
}
</style>
